<template>
  <a-drawer :visible="visible"
            :title="title"
            width="60%"
            :destroyOnClose="true"
            @close="onClose">
    <div>
      <From ref="formRef"
            layoutType="grid"
            :isErrorMessage="false"
            :optionList="formRows"
            :formRules="formRules"
            :defaultModel="defaultModel"
            @change="selectChange">
      </From>
      <div class="footer-but">
        <a-button style="margin-right: 8px"
                  @click="onClose"> 取消 </a-button>
        <a-button class="first-but"
                  @click="handleIssue('1')"> 保存 </a-button>
        <a-button class="first-but"
                  type="primary"
                  @click="handleIssue('0')">
          发布
        </a-button>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { increasedEssay, addArticle } from '@/api/back-essay'
import From from '@/views/Back/components/formTable/form'
import { formRows, formRules, limitList } from '../config/fromConfigOptions'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    options: Array, //模块筛选值
    title: String,
    rows: Object
  },
  data() {
    return {
      formRows, // 表单item配置
      formRules, // 表单校验规则配置
      defaultModel: {},
      warningStr: '' // 超出限制提示
    }
  },
  watch: {
    rows(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.title !== '详情') {
            this.commonCheck(val.moduleId)
          }
        })
        this.handleResult(val) // 处理结果为想要的格式
      }
    },
  },
  mounted() {
    formRows.forEach((item) => {
      if (item.prop === 'module') {
        item.list = this.options
      }
    })
  },
  methods: {
    async handleIssue(status) {
      const v1 = this.$refs.formRef.validatedForm()
      const { picPath, author, content, link, module, title, summary,annexIds,publishTime } =
        this.$refs.formRef.formModel
        
      let pic = null
      if (picPath !== undefined && picPath.length > 0) {
        if (this.title === '新增') {
          pic = this.handlerPicPathIds(picPath).join(',')
        } else {
          pic = picPath[0].id || picPath[0].response[0].fileId
        }
      } else {
        pic = null
      }
      let appendix
      
      if (annexIds !== undefined && annexIds.length > 0) {
        if (this.title === '新增') {
          appendix = this.handlerPicPathIds(annexIds).join(',')
        } else {
          
          appendix = this.handlerFileIds(annexIds).join(',') || this.handlerPicPathIds(annexIds).join(',')
        }
      } else {
        appendix = null
      }
      
      if (this.warningStr !== '' && status === '0') {
        this.$message.warning(this.warningStr)
        return
      }
      if (!v1) {
        return false
      }
      let params = {
        status: status,
        author,
        moduleId: module,
        title,
        content,
        link,
        picture: pic,
        summary,
        appendix,
        publishTime
      }
      
      let res = null
      if (this.title === '新增') {
        res = await increasedEssay(params)
      } else {
        params.id = this.rows.id
        res = await addArticle(params)
      }
      if (res.code === 200) {
        this.$message.success(this.title + '成功!')
        this.$emit('addSuccess')
      } else {
        this.$message.warning(res.msg)
      }
    },
    handlerFileIds(file) {
      
      if (!file) return []
      return file.reduce((pre, item) => {
        let fileId
        if(item.fileId) {
          fileId = item.fileId
        }else{
          fileId = item.response.data[0].fileId
          
        }
        
        pre.push(fileId)
        return pre
      }, [])
    },
    handlerPicPathIds(picPath) {
      
      if (!picPath) return []
      return picPath.reduce((pre, item) => {
        let fileId
        if(item.fileId) {
          fileId = item.fileId
        }else{
          fileId = item.response[0].fileId || item.response.data[0].fileId
        }
        pre.push(fileId)
        return pre
      }, [])
    },
    onClose() {
      this.$emit('shut')
    },
    handleResult(instance) {
      const { author, moduleId, title, content, link, systemFile,publishTime, summary,appendixFiles } =
        instance
      const picPath = []
      const annexIds = []
      this.defaultModel = {
        author,
        module: moduleId,
        title,
        content,
        link,
        summary,
        publishTime: moment(publishTime).format('YYYY-MM-DD HH:mm:ss')
      }
      if (systemFile) {
        picPath.push(systemFile)
        this.defaultModel.picPath = picPath
      }
      if(appendixFiles) {
        annexIds.push(...appendixFiles)
        this.defaultModel.annexIds = annexIds
      }
      
    },
    // 中心服务（做限制，只可发布一篇文章）、分析报告、竞赛动态、培训讲座、相关咨询、政策法规、热门问题(做限制，只可发布九篇文章） 默认为文章；新闻速华师信息素养培训资料、华师知识产权数据库、国内外官方网站及数据库 默认为链接；
    selectChange(val) {
      if (val && val.prop === 'module') {
        this.commonCheck(val.value)
      }
    },
    commonCheck(val) {
      this.$set(this.formRules, 'link', [])
      this.warningStr = ''
      this.options.forEach((item) => {
        if (item.value === val) {
          limitList.forEach((ele) => {
            if (ele.code === item.code) {
              if (ele.isLimit) {
                if (item.num >= item.limitNum) {
                  this.warningStr =
                    item.menuName + '发布数量以达到上限，请下架后再发布!'
                  // this.$message.warning(this.warningStr)
                }
              }
              if (ele.isLink) {
                let link = [
                  {
                    required: true,
                    message: '链接不能为空',
                    trigger: 'blur'
                  }
                ]
                this.$set(this.formRules, 'link', link)
                this.formRows.forEach((res) => {
                  if (res.prop === 'link') {
                    this.$set(res, 'disabled', false)
                    this.$refs.formRef.updateFormConfig('link', res)
                  }
                  if (res.prop === 'author') {
                    this.$set(res, 'disabled', true)
                    this.$refs.formRef.updateFormConfig('author', res)
                  }
                })
              } else {
                // 文章时链接不能填,作者能填
                this.formRows.forEach((res) => {
                  if (res.prop === 'link') {
                    this.$set(res, 'disabled', true)
                    this.$refs.formRef.updateFormConfig('link', res)
                  }
                  if (res.prop === 'author') {
                    this.$set(res, 'disabled', false)
                    this.$refs.formRef.updateFormConfig('author', res)
                  }
                })
              }
            }
          })
        }
      })
      if (this.title === '编辑') {
        console.log('this.rows.moduleStr', this.rows.moduleStr)
        if (this.rows.moduleStr === '新闻速递') {
          this.$nextTick(() => {
            this.formRows.forEach((item, i) => {
              if (item.prop === 'link') {
                  this.$set(this.formRows[i], 'disabled', true)
                }
            })
          })
        }
      }
    }
  },
  components: {
    From
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-btn {
  color: #fff;
  background: linear-gradient(0deg, #2087fb, #73d3ff) !important;
}
</style>
